import { render } from "./DashboardNeedsProfile.vue?vue&type=template&id=39e85da5"
import script from "./DashboardNeedsProfile.vue?vue&type=script&lang=js"
export * from "./DashboardNeedsProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__